import { LoanDocState } from 'gql/graphql';

export interface LenderItemTransformOptions {
  stateCondition?: (doc: any) => boolean;
  stateValueIfTrue?: string;
  stateValueIfFalse?: string;
}

/**
 * Transforma los items de lender con documentos de loan
 */
export const transformLenderItemsLoanDoc = (
  item: any,
  loanDocKey: string,
  loanDocs: any[],
  {
    stateCondition,
    stateValueIfTrue = "APPROVED",
    stateValueIfFalse = "DRAFT",
  }: LenderItemTransformOptions = {}
) => {
  const doc = loanDocs?.find(loanDoc => loanDoc.key === loanDocKey);
  
  if (stateCondition) {
    item.state = stateCondition(doc) ? stateValueIfTrue : stateValueIfFalse;
  }

  // Asignar archivos
  if (doc?.file || doc?.files?.length === 1) {
    item.loanDoc = { file: doc.file || (doc.files && doc.files[0]), hidden: doc.hidden };
    item.numberOfFiles = 1;
  } else if (doc?.files && doc?.files?.length > 1) {
    item.loanDoc = { file: doc.files[0], hidden: doc.hidden };
    item.numberOfFiles = doc.files.length;
  }
};

/**
 * Procesa todos los items de lender para una fase específica
 */
export const processLenderTaskItems = (
  phase: any, 
  loanDocs: any[], 
  rulesTasksCards: any[], 
  loan: any
) => {
  phase.lenderTasks?.forEach((item: any) => {
    const itemProcessors = {
      term_sheet: () => transformLenderItemsLoanDoc(item, "term_sheet", loanDocs),
      
      pre_approval_letter: () => transformLenderItemsLoanDoc(item, "pre_approval", loanDocs),
      
      appraisal_ordered: () => transformLenderItemsLoanDoc(item, "appraisal", loanDocs, {
        stateCondition: doc => !!doc && doc.state !== LoanDocState.Pending
      }),
      
      title_requested: () => transformLenderItemsLoanDoc(item, "title", loanDocs, {
        stateCondition: doc => !!doc && doc.state !== LoanDocState.Pending
      }),
      
      credit_check: () => {
        const approved = loanDocs?.find(d => d.name.includes("Credit Report") && d.state === LoanDocState.Approved);
        const pending = loanDocs?.find(d => d.name.includes("Credit Report") && d.state !== LoanDocState.Approved);
        item.state = approved && !pending ? "APPROVED" : "DRAFT";
      },
      
      background_check: () => {
        const approved = loanDocs?.find(d => d.name.includes("Background Check") && d.state === LoanDocState.Approved);
        const pending = loanDocs?.find(d => d.name.includes("Background Check") && d.state !== LoanDocState.Approved);
        item.state = approved && !pending ? "APPROVED" : "DRAFT";
      },
      
      appraisal_approved: () => transformLenderItemsLoanDoc(item, "appraisal", loanDocs, {
        stateCondition: doc => doc?.state === LoanDocState.Approved
      }),
      
      insurance_verified: () => transformLenderItemsLoanDoc(item, "insurance", loanDocs, {
        stateCondition: doc => doc?.state === LoanDocState.Approved,
      }),
      
      track_record_verified: () => {
        const taskInvestment = rulesTasksCards.find(taskCard => taskCard.key === "track_record");
        if (!taskInvestment) {
          item.exclude = true;
          return;
        }
        item.state = taskInvestment.state || "DRAFT";
      },
      
      title_verified: () => transformLenderItemsLoanDoc(item, "title", loanDocs, {
        stateCondition: doc => doc?.state !== LoanDocState.Requested,
      }),
      
      title_cleared: () => transformLenderItemsLoanDoc(item, "title", loanDocs, {
        stateCondition: doc => doc?.state === LoanDocState.Cleared,
      }),
      
      lender_cleared_to_close: () => {
        item.state = loan.salesforceData?.lenderClearToClose ? "APPROVED" : "DRAFT";
      },
      
      closing_docs: () => transformLenderItemsLoanDoc(item, "closing_docs", loanDocs, {
        stateCondition: doc => doc?.state === LoanDocState.Approved,
      })
    };
    
    const processor = itemProcessors[item.key as keyof typeof itemProcessors];
    
    if (processor) {
      processor();
    }
  });
};